import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
// 登录注册
import login from '../views/login.vue'
// 敬请期待
import waiting from '../views/waiting.vue'
// 菜单页
import menu from '../views/menu.vue'
import agenda from '../views/agenda.vue'
import investigation from '../views/investigation.vue'
import contact from '../views/contact.vue'

// 参会须知
import guest from '../views/guest.vue'
import signin from '../views/guest/signin.vue'
import face from '../views/guest/face.vue'
import earphone from '../views/guest/earphone.vue'
import hotel from '../views/guest/hotel.vue'
import out from '../views/guest/out.vue'
import out1 from '../views/guest/out1.vue'
import timetable from '../views/guest/timetable.vue'

// 会议查询
import meetingS from '../views/meetingS.vue'
import theme from '../views/meetingS/theme.vue'
import yhquery from '../views/meetingS/yhquery.vue'

// 视频集锦
import photo from '../views/photo.vue'
import videos from '../views/photo/videos.vue'
import say from '../views/photo/say.vue'

// 会议资料
import meetingL from '../views/meetingL.vue'
import meeting from '../views/meetingL/meeting.vue'
import pdf from '../views/meetingL/pdf.vue'

Vue.use(Router)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
},
{
    path: '/login',
    name: 'login',
    component: login
},
{
    path: '/waiting',
    name: 'waiting',
    component: waiting
},
{
    path: '/menu',
    name: 'menu',
    component: menu
},
{
    path: '/guest',
    name: 'guest',
    component: guest
},
{
    path: '/signin',
    name: 'signin',
    component: signin
},
{
    path: '/face',
    name: 'face',
    component: face
},
{
    path: '/earphone',
    name: 'earphone',
    component: earphone
},
{
    path: '/hotel',
    name: 'hotel',
    component: hotel
},
{
    path: '/out',
    name: 'out',
    component: out
},
{
    path: '/out1',
    name: 'out1',
    component: out1
},
{
    path: '/timetable',
    name: 'timetable',
    component: timetable
},
{
    path: '/agenda',
    name: 'agenda',
    component: agenda
},
{
    path: '/meetingS',
    name: 'meetingS',
    component: meetingS
},
{
    path: '/theme',
    name: 'theme',
    component: theme
},
{
    path: '/yhquery',
    name: 'yhquery',
    component: yhquery
},
{
    path: '/photo',
    name: 'photo',
    component: photo
},
{
    path: '/videos',
    name: 'videos',
    component: videos
},
{
    path: '/say',
    name: 'say',
    component: say
},
{
    path: '/investigation',
    name: 'investigation',
    component: investigation
},
{
    path: '/meetingL',
    name: 'meetingL',
    component: meetingL
},
{
    path: '/meeting',
    name: 'meeting',
    component: meeting
},
{
    path: '/contact',
    name: 'contact',
    component: contact
},
{
    path: '/pdf',
    name: 'pdf',
    component: pdf
}
]

const router = new Router({
    routes
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js